import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as formActions from 'modules/form';
import Form from 'components/Contact/Form';
import Modal from 'components/Contact/Modal';

class FormContainer extends Component {

  render() {
    const { notice, alertMessage, FormActions } = this.props;

    return (
      <div>
        <Form {...this.props}/>
        {
          notice ? (
            <Modal FormActions={FormActions} alertMessage={alertMessage}/>
          ) : null
        }
      </div>
    );
  }
}

export default connect(
  (state) => ({
    name: state.form.get('name'),
    tel: state.form.get('tel'),
    email: state.form.get('email'),
    about: state.form.get('about'),
    message: state.form.get('message'),
    brand: state.form.get('brand'),
    notice: state.form.get('notice'),
    alertMessage: state.form.get('alertMessage'),
  }),
  (dispatch) => ({
    FormActions: bindActionCreators(formActions, dispatch)
  })
)(FormContainer);



// WEBPACK FOOTER //
// ./src/containers/FormContainer.js